const TOOLTIP_VARIANTS = ["dark", "light"];
const TOOLTIP_POSITIONS = ["auto", "bottom", "bottomStart", "bottomEnd", "top", "topStart", "topEnd", "start", "startTop", "startBottom", "end", "endTop", "endBottom"];

export { TOOLTIP_POSITIONS, TOOLTIP_VARIANTS };
